// KEZ theme — theme.js

(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var nav = document.getElementById('mobile-nav');
  var openBtn = document.querySelector('[data-kez-nav-open]');
  var closeBtn = document.querySelector('[data-kez-nav-close]');

  function setNav(open) {
    if (!nav) return;
    nav.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && closeBtn) closeBtn.focus();
    if (!open && openBtn) openBtn.focus();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setNav(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setNav(false); });
  if (nav) {
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setNav(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !nav.hidden) setNav(false);
    });
  }

  /* ---------- Money ---------- */
  function money(cents, root) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (err) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  }

  /* ---------- Pack picker / add to cart ---------- */
  function applyPlan(price, option) {
    if (!option) return price;
    var type = option.getAttribute('data-adj-type');
    var value = parseFloat(option.getAttribute('data-adj-value'));
    if (isNaN(value)) return price;
    if (type === 'percentage') return Math.round(price * (100 - value) / 100);
    if (type === 'fixed_amount') return Math.max(0, price - value);
    if (type === 'price') return value;
    return price;
  }

  function initBuy(root) {
    var idInput = root.querySelector('[data-kez-variant-id]');
    var packs = root.querySelectorAll('[data-kez-pack]');
    var qtyInput = root.querySelector('[data-kez-qty-input]');
    var submit = root.querySelector('[data-kez-submit]');
    var submitLabel = root.querySelector('[data-kez-submit-label]');
    var total = root.querySelector('[data-kez-total]');
    var planInput = root.querySelector('[data-kez-plan-id]');
    var planSelect = root.querySelector('[data-kez-plan-select]');
    var buyTypes = root.querySelectorAll('[data-kez-buytype]');
    var scope = root.closest('.shopify-section') || document;
    var isProductPage = !!scope.querySelector('.product-page');
    var basePrice = total ? parseInt(total.getAttribute('data-price'), 10) : null;
    if (isNaN(basePrice)) basePrice = null;

    function selectedPack() {
      for (var i = 0; i < packs.length; i++) if (packs[i].checked) return packs[i];
      return null;
    }

    function subscribing() {
      if (!planInput) return false;
      if (!buyTypes.length) return true;
      for (var i = 0; i < buyTypes.length; i++) {
        if (buyTypes[i].checked) return buyTypes[i].value === 'sub';
      }
      return false;
    }

    function update(fromUser) {
      var pack = selectedPack();
      var price = pack ? parseInt(pack.getAttribute('data-price'), 10) : basePrice;
      var soldOut = pack ? pack.hasAttribute('data-soldout') : false;

      if (pack && idInput) idInput.value = pack.value;

      if (planInput) {
        var sub = subscribing();
        var option = planSelect ? planSelect.options[planSelect.selectedIndex] : null;
        planInput.value = sub && option ? option.value : '';
        if (sub && price !== null) price = applyPlan(price, option);
      }

      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (total && price !== null && !isNaN(price)) total.textContent = money(price * qty, root);

      if (submit && pack) {
        submit.disabled = soldOut;
        if (submitLabel) submitLabel.textContent = soldOut ? 'Sold out' : submit.getAttribute('data-label');
      }

      if (pack) {
        // Swap the drawn pack, or the photo, to match.
        var count = pack.getAttribute('data-count');
        var stages = scope.querySelectorAll('[data-kez-stage]');
        for (var s = 0; s < stages.length; s++) {
          stages[s].hidden = stages[s].getAttribute('data-kez-stage') !== count;
        }
        var image = pack.getAttribute('data-image');
        var featured = scope.querySelector('[data-kez-featured]');
        if (fromUser && image && featured) featured.src = image;

        if (fromUser && isProductPage && window.history && history.replaceState) {
          var url = pack.getAttribute('data-url');
          if (url) history.replaceState({}, '', url);
        }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-kez-plan-select]')) {
        for (var i = 0; i < buyTypes.length; i++) if (buyTypes[i].value === 'sub') buyTypes[i].checked = true;
      }
      update(true);
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kez-qty]');
      if (!btn || !qtyInput) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-kez-qty'), 10);
      qtyInput.value = Math.max(1, next);
      update(false);
    });

    update(false);
  }

  var buys = document.querySelectorAll('[data-kez-buy]');
  for (var b = 0; b < buys.length; b++) initBuy(buys[b]);

  /* ---------- Product photo thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-kez-thumb]');
    if (!thumb) return;
    var featured = document.querySelector('[data-kez-featured]');
    if (featured) featured.src = thumb.getAttribute('data-kez-thumb');
    var all = document.querySelectorAll('[data-kez-thumb]');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('product-thumb--active');
    thumb.classList.add('product-thumb--active');
  });
})();
